import React from 'react';
import Box from '../Box/Box.styled';
import FlexBox from '../Box/FlexBox.styled';
import Navbar from '../Navbar/Navbar';

type PageProps = {
  children?: React.ReactNode;
};

const Page = ({ children }: PageProps) => {
  return (
    <Box>
      <FlexBox>
        <Navbar />
      </FlexBox>
      {children}
    </Box>
  );
};

export default Page;
